import ClienteController from "@/shared/controllers/cliente/clienteController";
import EmpresaController from "@/shared/controllers/empresa/empresaController";
import OrcamentoController from "@/shared/controllers/orcamento/orcamentoController";
import ProdutoController from "@/shared/controllers/produto/produtoController";
import NovoPedidoViewModel from "@/shared/view-models/NovoPedidoViewModel";

const name = "GerarNovoPedidoInicio";
export default {
  name,

  components: {},

  props: {},

  mounted() {
    this.getordenacao()

    this.EmpresaArray = this.$store.state.EmpresaArray;
    this.filtroNovoPedido.RepresentanteId = this.$store.state.representanteSelecionadoId;
    this.getStatus()
    this.mitt.on('trocaEmpresaRepresentante', () => {
      this.atualizaEmpresaRepresentante()
    })

    this.buscarLinhaProducao()
  },

  updated() {},

  data() {
    return {
      EmpresaArray: null,
      UnidadeSelecionada: null,
      UnidadeArray: null,
      StatusArray: [],
      ClientesArray: [],
      ClienteSelecionado: null,
      filtroNovoPedido: new NovoPedidoViewModel(),
      timer: null,
      ordenacaoArray: [],
      LinhaProducaoArray: [],
      ProdutoNovoArray: null,
      ProdutoArray: null
    };
  },

  methods: {
    Continuar() {
      this.axios({
        method: "get",
        data: this.formSearch,
        url:
          process.env.VUE_APP_WEB_API + "GerarNovoPedido/ExcluiPedidosEmDigitacaoComSequenciaCancelada",
      })
        .then(() => {
        })
        .finally(()=> {
          try{
            this.$store.state.filtroNovoPedido = this.filtroNovoPedido
            this.$store.commit('salvando');
            this.$router.push(`/gerar-novo-pedido-orcamento`);
          }
          catch{
            this.$toast.add({ severity: 'error', summary: 'Erro realizar filtro', detail: '-', life: 4000 });
          }        
        })
    },
    getordenacao () {
      OrcamentoController.GetEnumOrdenacao().requisicao
        .then((res => {
          this.ordenacaoArray = res.data
          this.filtroNovoPedido.Ordenacao = res.data[0].value
        }))
        .catch()
    },

    popularDropDownEmpresa(){
      this.EmpresaArray = EmpresaController.getEmpresasAtivas().EmpresaArray;
      this.atualizaEmpresaRepresentante()
      },

    buscarClientes(event){
      window.clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.ClientesArray = ClienteController.getClienteDropDownsByNome(event, this.filtroNovoPedido.UnidadeId).ClientesArray;
      }, 1000);
    },

    atualizaEmpresaRepresentante(){
      this.filtroNovoPedido.UnidadeId = this.$store.state.empresaSelecionadaId;
      this.filtroNovoPedido.RepresentanteId = this.$store.state.representanteSelecionadoId;
    },

    buscarLinhaProducao(){
    window.clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        OrcamentoController.getLinhaProducaoDropDownsByNome().requisicao
        .then(response => {
          this.LinhaProducaoArray = response.data.data
        })
      }, 1000);
    },
    getProduto(pesquisa) {
      window.clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        ProdutoController.GetProdutoDropDownByPesquisaRepresentanteEmpresa(pesquisa, this.$store.state.representanteSelecionadoId, this.filtroNovoPedido.UnidadeId).requisicao
        .then((res) => {
          this.ProdutoArray = res.data.data
        })
        .catch()
      }, 1000);
    },
    getCodigo(produtoId){
      ProdutoController.GetCodigoByProdutoId(produtoId).requisicao
        .then((res) => {
          this.filtroNovoPedido.CodigoProduto = res.data.message

        })
        .catch()

    },
    getProdutoNovo(pesquisa) {
      window.clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        ProdutoController.GetProdutoNovoByPesquisaRepresentante(pesquisa, this.$store.state.representanteSelecionadoId, this.filtroNovoPedido.UnidadeId).requisicao
        .then((res) => {
          this.ProdutoNovoArray = res.data.data
        })
        .catch()
      }, 1000);
    },
    getStatus() {
      OrcamentoController.GetStatusOrcamentoEnumPedido().requisicao
        .then((res => {
          this.StatusArray = res.data
          this.filtroNovoPedido.Status = res.data[0].value
        }))
        .catch()
    }

  },

  computed: {},
};
